@if (showDialog) {
  <div >
    <div class="god_off">
      <div class="game-over-cont" [class.game-over-animation]="showDialog"> <!--game.status=='complete'">-->
        <div class="game-over-header">Reality Check</div>
        <!--<h2 *ngIf="wins" class="game-over-your-wins">Your Wins:</h2>-->
        <div class="game-over-details-cont ion-text-left-">
          <div class="ion-text-center">
            <br><br>
            {{ noteToSelf }}
            <br>
            <br>

            <ion-button (click)="closeDialog()" class="game-over-form-button" >Close Reality Check</ion-button>
            <ion-button (click)="openMyaccount()" class="game-over-form-button" >My account</ion-button>
            <!--          <button (click)="gotoAccounts()" class="game-over-form-button" ion-button>Account History</button>-->
            <ion-button (click)="clearUserSessionToken()" class="game-over-form-button" >Logout</ion-button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
